import {PaymentPeriodType} from "@portal-workspace/grow-shared-library";

export type CurrencyWithPeriodValue = {
  amount: number,
  period: PaymentPeriodType,
} | null
